module.exports = __webpack_public_path__ + "img/industry-banner-crm-04.b5a39ae6.png";